var CampaignRequestView = function () { return import(/* webpackChunkName: "campaign-request-views" */ '@/app/views/campaign_request/CampaignRequestView.vue'); };
var CampaignRequestWelcomeView = function () { return import(/* webpackChunkName: "campaign-request-views" */ '@/app/views/campaign_request/CampaignRequestWelcomeView.vue'); };
var CampaignRequestFormView = function () { return import(/* webpackChunkName: "campaign-request-views" */ '@/app/views/campaign_request/CampaignRequestFormView.vue'); };
var CampaignRequestAssignmentsView = function () { return import(/* webpackChunkName: "campaign-request-views" */ '@/app/views/campaign_request/CampaignRequestAssignmentsView.vue'); };
var CampaignRequestBillingDetailsView = function () { return import(/* webpackChunkName: "campaign-request-views" */ '@/app/views/campaign_request/CampaignRequestBillingDetailsView.vue'); };
var CampaignRequestSummaryView = function () { return import(/* webpackChunkName: "campaign-request-views" */ '@/app/views/campaign_request/CampaignRequestSummaryView.vue'); };
var CampaignRequestDoneView = function () { return import(/* webpackChunkName: "campaign-request-views" */ '@/app/views/campaign_request/CampaignRequestDoneView.vue'); };
var CampaignRequestIntegrationsView = function () { return import(/* webpackChunkName: "campaign-request-views" */ '@/app/views/campaign_request/CampaignRequestIntegrationsView.vue'); };
export var campaignRequestRoutes = [
    {
        path: 'campaign-request',
        component: CampaignRequestView,
        name: 'CampaignRequest',
        redirect: { name: 'CampaignRequest.Welcome' },
        props: true,
        children: [
            {
                path: '',
                name: 'CampaignRequest.Welcome',
                component: CampaignRequestWelcomeView,
            },
            {
                path: '',
                name: 'CampaignRequest.Form',
                component: CampaignRequestFormView,
            },
            {
                path: '',
                name: 'CampaignRequest.Integrations',
                component: CampaignRequestIntegrationsView,
            },
            {
                path: '',
                name: 'CampaignRequest.Assignments',
                component: CampaignRequestAssignmentsView,
            },
            {
                path: '',
                name: 'CampaignRequest.Billing',
                component: CampaignRequestBillingDetailsView,
            },
            {
                path: '',
                name: 'CampaignRequest.Summary',
                component: CampaignRequestSummaryView,
            },
            {
                path: '',
                name: 'CampaignRequest.Done',
                component: CampaignRequestDoneView,
            },
        ],
    },
];
